<script setup lang="ts">
  defineOptions({
    name: 'AuthLayout',
  })

  import { computed } from 'vue'

  import { useRoute } from 'nuxt/app'

  import { useLocation } from '@common/location-layer/composables/useLocation'

  const route = useRoute()

  const { store: locationStore } = useLocation()

  const brandColor1 = computed(() => locationStore.branding.brandColor1)

  const brandColor2 = computed(() => locationStore.branding.brandColor2)

  const backgroundStyle = computed(() => {
    if (brandColor1.value && brandColor2.value) {
      return {
        backgroundImage: `linear-gradient(180deg, ${brandColor1.value} 0%, ${brandColor2.value} 64.42%)`,
      }
    }

    return {
      backgroundImage: 'var(--cp-auth-default-gradient)',
    }
  })
</script>

<template>
  <div class="auth-layout-background" :style="backgroundStyle">
    <div class="auth-card-container">
      <div class="auth-card bg-background">
        <div class="auth-content-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .auth-layout-background {
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
  }

  .auth-card-container {
    width: 100%;
    max-width: 28rem;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
  }

  .auth-card {
    width: 100%;
    padding: 1rem;
    border-radius: 0.75rem;
    box-shadow:
      0 25px 50px -12px rgba(0, 0, 0, 0.25),
      0 0 0 1px rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
  }

  @media (max-width: 640px) {
    .auth-layout-background {
      padding: 1rem;
    }

    .auth-card {
      padding: 1.5rem;
    }
  }
</style>
